import { render, staticRenderFns } from "./FnfLeagueGames.vue?vue&type=template&id=2066d716&"
import script from "./FnfLeagueGames.vue?vue&type=script&lang=js&"
export * from "./FnfLeagueGames.vue?vue&type=script&lang=js&"
import style0 from "./FnfLeagueGames.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports